import { useMemo, memo } from "react";

import Cookies from "js-cookie";

import { CategoryTemplateOrder } from "../../config/category-template-order";
import { useQueryLocale } from "../hooks/use-query-locale";
import { useSearchRecommendations } from "../hooks/use-search-recommendations";

import {
    parseSearchQuery,
    TemplateInitialSearchResults
} from "./contentful-relay-components/template-initial-search-results-contentful-relay";

export function getTemplateRecommendationsSearchResultsQueryVars(
    location: Location
) {
    let anonymousId = "";
    try {
        anonymousId = JSON.parse(
            decodeURIComponent(Cookies.get("ajs_anonymous_id") || `""`)
        );
    } catch (error) {
        console.log(`Error parsing anonymousId ${error}`);
        anonymousId = Cookies.get("ajs_anonymous_id") || "";
    }
    return {
        // NOTE: There is a hardcoded exemption in GRS to return nothing when
        // the first 9 recommendations match a default set. This appears to have
        // been a specific ask, but is nonetheless very unexpected.
        // See: https://atlassian.slack.com/archives/C053051JN9Y/p1729642717332069?thread_ts=1729620526.565589&cid=C053051JN9Y
        first: 9,
        context: {
            useCase: "wacConfluenceTemplates",
            product: "marketing",
            anonymousId,
            userId: Cookies.get("__aid_user_id") || "",
            custom: {
                paidSearchTerm: new URLSearchParams(location.search).get(
                    "keyword"
                )
            }
        }
    };
}

export const TemplateRecommendationsSearchResults = memo(() => {
    const recommendationData = useSearchRecommendations();

    const locale = useQueryLocale();

    const searchQuery = useMemo(() => {
        return parseSearchQuery(
            // @ts-ignore
            recommendationData.growthRecommendations?.recommendations?.data?.map(
                // @ts-ignore
                (rec) => rec.entityId
            ) ?? { type: "category", id: "recommended" }
        );
    }, [recommendationData]);

    return (
        <TemplateInitialSearchResults
            searchKey="recommended"
            urlSlugs={searchQuery.whereClause?.["urlSlugs"] ?? []}
            templateIds={searchQuery.whereClause?.["templateIds"] ?? []}
            categoryUrlSlugs={
                searchQuery.whereClause?.["categoryUrlSlugs"] ?? []
            }
            sortLookup={CategoryTemplateOrder["recommended"]}
            limit={searchQuery.first}
            skip={0}
            locale={locale}
        />
    );
});
